import { Badge } from "../ui/badge";
import { CheckCircle, WarningCircle, Circle } from "@phosphor-icons/react";

export function StatusPill({ connection, testid }) {
  if (!connection) return <Badge variant="secondary" className="gap-1" data-testid={testid}><Circle size={10} /> Not connected</Badge>;
  if (connection.status === "error") return <Badge variant="outline" className="gap-1 text-red-600 border-red-300" data-testid={testid}><WarningCircle size={12} /> Needs attention</Badge>;
  return <Badge className="gap-1 bg-emerald-600 hover:bg-emerald-600 text-white" data-testid={testid}><CheckCircle size={12} weight="fill" /> Connected</Badge>;
}

export function fmtWhen(iso) {
  if (!iso) return "never";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function CardShell({ title, icon, item, children, testid, right }) {
  return (
    <div className="rounded-lg border border-border bg-card p-4 space-y-3" data-testid={testid}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <div className="h-9 w-9 rounded-md bg-muted flex items-center justify-center shrink-0">{icon}</div>
          <div>
            <p className="text-sm font-semibold">{title}</p>
            <p className="text-[11px] text-muted-foreground leading-snug">{item?.blurb}</p>
          </div>
        </div>
        <div className="flex flex-col items-end gap-1">
          <StatusPill connection={item?.connection} testid={`${testid}-status`} />
          {right}
        </div>
      </div>
      {item?.connection?.last_error && (
        <p className="text-[11px] text-red-600 rounded bg-red-50 dark:bg-red-950/30 px-2 py-1" data-testid={`${testid}-error`}>{item.connection.last_error}</p>
      )}
      {children}
    </div>
  );
}

export function AppNotConfigured({ item, testid }) {
  if (!item?.app || item.app.configured) return null;
  return (
    <p className="text-[11px] rounded bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-900 text-amber-800 dark:text-amber-300 px-2 py-1.5" data-testid={testid}>
      One-click connect isn't available yet — no app credentials for {item.name}. An admin can add your own app's Client ID/secret under <b>App credentials</b> below, or the platform can provide them.
    </p>
  );
}
